import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import { getTaskTmp as _getTaskTmp, createTmp, updateTmp, validTaskTmp } from '@/api/template';
import TemplateEditor from '@/components/common/template-editor';
import { transformParamsToData, transformParamsToForm, transformToData, transformToForm } from "@/components/common/transformData";
export default {
  name: "template-content",
  components: {
    TemplateEditor: TemplateEditor
  },
  props: {
    id: {
      default: undefined
    },
    copy: {
      default: function _default() {
        return false;
      }
    },
    isInCorrespondence: {
      default: function _default() {
        return false;
      }
    },
    toolFixed: {
      default: function _default() {
        return false;
      }
    },
    taskId: {
      default: function _default() {
        return undefined;
      }
    }
  },
  computed: {
    isCopy: function isCopy() {
      return this.copy;
    }
  },
  data: function data() {
    return {
      template: null,
      loading: false,
      form: {
        ctIssue: false,
        share: false,
        use: false,
        belong: '',
        revise: '',
        desc: '',
        Items: [],
        name: '',
        editorVal: undefined,
        createDate: undefined,
        updateDate: undefined,
        from: undefined
      },
      list: []
    };
  },
  methods: {
    getTaskTmp: function getTaskTmp() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$_getTaskTmp, data, params;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this.loading = true;
              _this.$emit('getLoading', true);
              _context.n = 1;
              return _getTaskTmp({
                TmpGuid: _this.id
              });
            case 1:
              _yield$_getTaskTmp = _context.v;
              data = _yield$_getTaskTmp.data;
              if (data) {
                if (data.tmp) {
                  params = data.tmp;
                  _this.form = transformToForm(params);
                  _this.ctConfirm = data.tmp.ctConfirm;
                }
                if (Array.isArray(data.elements)) {
                  _this.list = data.elements.map(function (item) {
                    return transformParamsToForm(item);
                  });
                }
              }
              _this.$emit('getLoading', false);
              _this.loading = false;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    submit: function submit() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _yield$_this2$$awaitT, _yield$_this2$$awaitT2, nameErr, params, _yield$_this2$$awaitT3, _yield$_this2$$awaitT4, err, _yield$_this2$$awaitT5, _yield$_this2$$awaitT6, _err;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$refs.editor.checkForm();
            case 1:
              if (!Array.isArray(_this2.form.Items)) {
                _this2.form.Items = [];
              }
              if (_this2.isInCorrespondence) {
                _context2.n = 9;
                break;
              }
              _this2.loading = true;
              _this2.$emit('getLoading', true);
              if (!(!_this2.id || _this2.isCopy)) {
                _context2.n = 3;
                break;
              }
              _context2.n = 2;
              return _this2.$awaitTo(validTaskTmp({
                TmpName: _this2.form.name
              }));
            case 2:
              _yield$_this2$$awaitT = _context2.v;
              _yield$_this2$$awaitT2 = _slicedToArray(_yield$_this2$$awaitT, 1);
              nameErr = _yield$_this2$$awaitT2[0];
              _this2.loading = false;
              _this2.$emit('getLoading', false);
              if (!nameErr) {
                _context2.n = 3;
                break;
              }
              return _context2.a(2);
            case 3:
              params = transformToData(_this2.form);
              if (!(_this2.id && !_this2.isCopy)) {
                _context2.n = 6;
                break;
              }
              _context2.n = 4;
              return _this2.$awaitTo(updateTmp({
                TmpId: _this2.id,
                Tmp: params,
                Elements: _this2.list.map(function (child) {
                  return _objectSpread({
                    CETmpId: _this2.id
                  }, transformParamsToData(child));
                })
              }));
            case 4:
              _yield$_this2$$awaitT3 = _context2.v;
              _yield$_this2$$awaitT4 = _slicedToArray(_yield$_this2$$awaitT3, 1);
              err = _yield$_this2$$awaitT4[0];
              _this2.loading = false;
              _this2.$emit('getLoading', false);
              if (!err) {
                _context2.n = 5;
                break;
              }
              return _context2.a(2);
            case 5:
              _this2.$message.success('更新成功');
              _this2.getTaskTmp();
              _context2.n = 9;
              break;
            case 6:
              if (_this2.isCopy) {
                params = _objectSpread(_objectSpread({}, params), {}, {
                  ctIssue: false,
                  ctShare: false,
                  ctUse: false
                });
              }
              _context2.n = 7;
              return _this2.$awaitTo(createTmp({
                Tmp: params,
                Elements: []
              }));
            case 7:
              _yield$_this2$$awaitT5 = _context2.v;
              _yield$_this2$$awaitT6 = _slicedToArray(_yield$_this2$$awaitT5, 1);
              _err = _yield$_this2$$awaitT6[0];
              _this2.loading = false;
              _this2.$emit('getLoading', false);
              if (!_err) {
                _context2.n = 8;
                break;
              }
              return _context2.a(2);
            case 8:
              _this2.$message.success('创建成功');
            case 9:
              _this2.$emit('submit', {
                data: _this2.form.ctConfirm,
                params: _this2.list
              });
            case 10:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    paramsChange: function paramsChange(type, data, list) {
      console.log(type, data, list);
    }
  },
  created: function created() {
    if (this.id) {
      this.getTaskTmp();
    }
  }
};